import { useLocation } from "react-router-dom";

import packageJson from "../../../package.json";
import routes from "../../shared/routes";
import { tenantLogoUrl } from "../../shared/tenantBranding";
import NavigationMenu from "./NavigationMenu";

export default function SideNavigationBar({
  outsideClickRef,
  user_type,
  tenant,
  onNavigate,
}) {
  const location = useLocation();
  const { routes: navigation } = routes(
    location.pathname,
    parseInt(user_type),
    tenant,
  );
  const logoSrc = tenantLogoUrl(tenant);
  const companyName = tenant?.name ?? "QA Trace";

  return (
    <aside
      className="layout-sidebar hide-for-print border-r border-slate-200 bg-white"
      ref={outsideClickRef}
      aria-label="Application sidebar"
    >
      <div className="flex min-h-0 grow flex-col px-4 pb-4">
        <div className="mb-4 flex min-h-24 shrink-0 items-center gap-3 border-b border-slate-200 px-2 py-5">
          {logoSrc ? (
            <img
              className="h-11 w-11 shrink-0 rounded-xl object-contain"
              src={logoSrc}
              alt={`${companyName} logo`}
            />
          ) : (
            <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-blue-600 text-base font-bold text-white shadow-sm">
              {companyName.charAt(0).toUpperCase()}
            </div>
          )}
          <div className="min-w-0">
            <p className="truncate text-base font-semibold text-slate-950">
              {companyName}
            </p>
          </div>
        </div>

        <NavigationMenu routes={navigation} onNavigate={onNavigate} />

        <div className="shrink-0 border-t border-slate-200 px-3 pt-4">
          <p className="text-xs font-medium text-slate-400">
            QA Trace · v{packageJson.version}
          </p>
        </div>
      </div>
    </aside>
  );
}
